/**
 * MODULE: brainLearningsNavCount.ts
 * PURPOSE: Derive top-nav learnings badge count from assistant brain context.
 * RECENT: 2026-06-06 [2.2.1330] — Count learned preferences, else eligible promotion candidates.
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 16 / 150 lines
 */

import type { AssistantContextResponse } from '@shared/lib/frontend/api/assistantContextApi';

/** Active learned preferences, or promotion-ready patterns when none promoted yet. */
export function brainLearningsNavBadgeCount(context: AssistantContextResponse | null): number {
  if (!context) return 0;
  const learned = context.learned_preferences?.length ?? 0;
  if (learned > 0) return learned;
  const eligible = context.promotion_pipeline?.eligible_candidates ?? 0;
  return eligible > 0 ? eligible : 0;
}
